document.addEventListener("alpine:init", () => {
    Alpine.data("octCampaign", () => ({
      loading: false,
      email: "",
      errMsg: "",
      isSuccess: false,

      async submitResult() {
        const isEmailValid = validateEmail(this.email);
        if (!isEmailValid) {
          this.errMsg = true;
          return;
        }
        // If no error, remove error message
        this.errMsg = "";

        const fieldsArray = createFieldsArray(campaignSettingJsons);
        // getContactListId function in subscription-form-common.js
        const contactListId = getContactListId(campaignSettingJsons);

        // Extract theme global variables from theme.liquid
        const { apiUrl, acceptedLanguage, apiKey, xAppid } =
          theme.emailSubscription;

        const apiBody = {
          email: this.email,
          contactListId,
          fields: fieldsArray,
        };

        const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
        let eventTracking = null;

        if (subscribeInfoCookie) {
          try {
            const decodedCookie = decodeURIComponent(subscribeInfoCookie)
            eventTracking = JSON.parse(decodedCookie);
            delete eventTracking.ts
            console.log('eventTracking', eventTracking);
          } catch (error) {
            console.log('eventTracking error', subscribeInfoCookie);
            console.warn('Failed to parse subscribe_info cookie:', error);
          }
        };

        const finalApiBody = {
          ...apiBody,
          ...(eventTracking && { eventTracking }),
        };

        this.loading = true;
        try {
          const response = await fetch(
            // Header global settings are defined in star-email-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            apiUrl,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apiKey: apiKey,
                traceId: traceId,
                "X-appid": xAppid,
                "Accepted-Language": acceptedLanguage,
              },
              body: JSON.stringify(finalApiBody),
            }
          );

          const data = await response.json();

          if (data.message === "Success") {
            this.isSuccess = true;
          }
        } catch (error) {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
        } finally {
          this.loading = false;
        }
      },
    }));
  });
